"use client";

import { c as _c } from "react/compiler-runtime";
import { HiOutlineClock } from "react-icons/hi2";
import { authService } from "@/services/auth-service";
export default function AccessExpiredScreen() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-full w-full items-center justify-center bg-background z-10 p-6"><div className="flex max-w-md flex-col items-center gap-4 text-center"><div className="rounded-full bg-primary/10 p-4"><HiOutlineClock className="h-10 w-10 text-primary" /></div><h1 className="text-h1 text-foreground">Thanks for trying Decoda Health</h1><p className="text-body-lg text-muted-foreground">We hope you enjoyed your experience. Book a follow-up or extend your time with us:</p><a href="https://calendly.com/chasem-decodahealth/decoda-health-follow-up" target="_blank" rel="noopener noreferrer" className="text-body-strong text-primary underline-offset-4 hover:underline">Schedule a follow-up</a><button onClick={_temp} className="mt-2 text-body text-muted-foreground underline-offset-4 hover:underline">Sign out</button></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp() {
  return authService.logout();
}